import axios from '@/libs/axios'

const API_BASE_URL = '/salones'

export default {
  // Obtener todos los salones
  async getAll() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching classrooms:', error)
      throw error
    }
  },

  // Obtener salones activos (el endpoint principal ya filtra por estado activo)
  async getActive() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching active classrooms:', error)
      throw error
    }
  },

  // Obtener un salón por ID
  async getById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching classroom:', error)
      throw error
    }
  },

  // Obtener salones por edificio
  async getByEdificio(edificioId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/by-edificio/${edificioId}`)
      return response.data
    } catch (error) {
      console.error('Error fetching classrooms by building:', error)
      throw error
    }
  },

  // Crear un nuevo salón
  async create(classroomData) {
    try {
      const response = await axios.post(API_BASE_URL, classroomData)
      return response.data
    } catch (error) {
      console.error('Error creating classroom:', error)
      throw error
    }
  },

  // Actualizar un salón
  async update(id, classroomData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}`, classroomData)
      return response.data
    } catch (error) {
      console.error('Error updating classroom:', error)
      throw error
    }
  },

  // Eliminar un salón
  async delete(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting classroom:', error)
      throw error
    }
  }
}